export default "__VITE_ASSET__ey_GZhYU__"